import React from 'react';
import { Route } from 'react-router-dom';
import { Routes as Switch } from 'react-router';
import JobActivity from '../../../JobProfile/JobActivity';
import DriverPool from '../../../JobProfile/DriverPool';
import JobManagement from '../../../JobManagement';
import JobMap from '../../../JobProfile/JobMap';
import LoadManagement from '../../../LoadManagement';
import EquipmentManagement from '../../../EquipmentManagement';
import JobProfile from '../../../JobProfile';
import Users from '../../../Users';
import { default as JobLoadsManagement } from '../../../JobProfile/LoadManagement';
import './Content.css';
import PrivateRoute from '../../../Auth/PrivateRoute';
import ProtectedRoute from '../../../Auth/ProtectedRoute/ProtectedRoute';
import { Routes } from '../../../../utils';
import EditJob from '../../../EditJob';
import LoadProfile from '../../../LoadProfile';
import LoadHistory from '../../../LoadProfile/LoadHistory';
import Permissions from '../../../Permissions';
import Customers from '../../../Customers';
import CustomerParents from '../../../CustomerParents';
import Crews from '../../../Crews';
import SilentRenew from '../../../Auth/SilentRenew';
import Lofas from '../../../Lofas/Lofas';
import Dashboard from '../../../Dashboard';
import DriverReport from '../../../DriverReport';
import SandboxBIReport from '../../../SandboxBIReport';

import Propants from '../../../Propants';
import Drivers from '../../../Drivers';
import Carriers from '../../../Carriers';
import Messages from '../../../Messages';
import MessagesDetail from '../../../Messages/MessagesDetail';
import MessagesCreate from '../../../Messages/MessagesCreate';
import Settings from '../../../Settings';
import DailySandAllocations from '../../../JobProfile/DailySandAllocations';
import JobMetrics from '../../../JobProfile/JobMetrics';
import JobStageSummary from '../../../JobProfile/StageSummary/JobStageSummary';
import JobStageSheet from '../../../JobProfile/StageSummary/StageSheet/StageSheet';
import JobStageSheetRO from '../../../JobProfile/StageSummary/StageSheet/StageSheetRO';
import JobManagementForTab from '../../../JobManagementForTab/JobManagementForTab';
import Inventory from '../../../JobProfile/Inventory/Inventory';
import AddBoxes from '../../../JobProfile/Inventory/AddBoxes';
import LoadFieldOp from '../../../LoadFieldOp';
import JobLogs from '../../../JobProfile/JobLogs/JobLogs';
import Yards from '../../../Yards/Yards';
import EquipmentProfile from '../../../EquipmentManagement/EquipmentDetails/EquipmentProfile';
import EditEquipmentDetails from '../../../EquipmentManagement/EquipmentDetails/EditEquipmentDetails/EditEquipmentDetails';
import EquipmentHistory from '../../../EquipmentManagement/EquipmentHistory/EquipmentHistory';
import EquipmentsForTab from '../../../JobProfile/Equipments/EquipmentsForTab';
import VosForTab from '../../../JobProfile/VOS/VosForTab';
import DashboardVos from '../../../Dashboard/DashboardVos/DashboardVos'
import DashboardMap from '../../../Dashboard/DashboardMap';
import StageSheetBellyDump from '../../../JobProfile/StageSummary/StageSheet/StageSheetBellyDump';
import StageSheetBellyDumpRO from '../../../JobProfile/StageSummary/StageSheet/StageSheetBellyDumpRO';


export const Content = (props: any): React.ReactElement => {
    return (
        <Switch>
            <Route element={<ProtectedRoute />}>
                <Route path={Routes.JOB_MANAGEMENT.route} element={<JobManagement />} />
                <Route path={Routes.JOB_MANAGEMENT_FOR_TAB.route} element={<JobManagementForTab />} />
                <Route path={Routes.LOAD_MANAGEMENT.route} element={<LoadManagement />} />
                <Route path={Routes.EQUIPMENT_WITH_ID.route} element={<EquipmentsForTab />} />
                <Route path={Routes.EQUIPMENT_MANAGEMENT.route} element={<EquipmentManagement />} />
                <Route path={Routes.EQUIPMENT_MANAGEMENT_WITH_ID.route} element={<EquipmentProfile />} />
                <Route path={Routes.EDIT_ASSET_LOAD_WITH_ID.route} element={<EditEquipmentDetails />} />
                <Route path={Routes.EQUIPMENT_HISTORY_WITH_ID.route} element={<EquipmentHistory />} />
                <Route path={Routes.MESSAGES.route} element={<Messages />} />
                <Route path={Routes.JOB_PROFILE_WITH_ID.route} element={<JobProfile />} />
                <Route path={Routes.EDIT_JOB_WITH_ID.route} element={<EditJob />} />
                <Route path={Routes.JOB_LOADS_WITH_ID.route} element={<JobLoadsManagement />} />
                <Route path={Routes.LOAD_PROFILE_WITH_ID.route} element={<LoadProfile />} />
                <Route path={Routes.LOAD_FIELD_OP_WITH_ID.route} element={<LoadFieldOp />} />
                <Route path={Routes.DRIVER_REPORT.route} element={<DriverReport />} />
                <Route path={Routes.POWER_BI_REPORT.route} element={<SandboxBIReport />} />
                <Route path={Routes.SYSTEM_ADMIN_USERS.route} element={<Users />} />
                <Route path={Routes.LOAD_HISTORY_WITH_ID.route} element={<LoadHistory />} />
                <Route path={Routes.SYSTEM_ADMIN_PERMISSIONS.route} element={<Permissions />} />
                <Route path={Routes.SYSTEM_ADMIN_LOFAS.route} element={<Lofas />} />
                <Route path={Routes.SYSTEM_ADMIN_CUSTOMERS.route} element={<Customers />} />
                <Route path={Routes.SYSTEM_ADMIN_CUSTOMER_PARENTS.route} element={<CustomerParents />} />
                <Route path={Routes.SYSTEM_ADMIN_CREWS.route} element={<Crews />} />
                <Route path={Routes.SYSTEM_ADMIN_DRIVERS.route} element={<Drivers />} />
                <Route path={Routes.SYSTEM_ADMIN_CARRIERS.route} element={<Carriers />} />
                <Route path={Routes.SYSTEM_ADMIN_PROPANTS.route} element={<Propants />} />
                <Route path={Routes.SYSTEM_ADMIN_SETTINGS.route} element={<Settings />} />
                <Route path={Routes.SYSTEM_ADMIN_YARDS.route} element={<Yards />} />
                <Route path={Routes.JOB_ACTIVITY_WITH_ID.route} element={<JobActivity />} />
                <Route path={Routes.STAGE_SUMMARY_WITH_ID.route} element={<JobStageSummary />} />
                <Route path={Routes.STAGE_SHEET_WITH_ID.route} element={<JobStageSheet />} />
                <Route path={Routes.STAGE_SHEET_BELLY_DUMP_WITH_ID.route} element={<StageSheetBellyDump/>}/>
                <Route path={Routes.STAGE_SHEET_BELLY_DUMP_RO_WITH_ID.route} element={<StageSheetBellyDumpRO/>}/>
                <Route path={Routes.STAGE_SHEET_RO_WITH_ID.route} element={<JobStageSheetRO />} />
                <Route path={Routes.INVENTORY_WITH_ID.route} element={<Inventory />} />
                <Route path={Routes.JOB_LOGS_WITH_ID.route} element={<JobLogs />} />
                <Route path={Routes.ADD_BOXES_WITH_ID.route} element={<AddBoxes />} />
                <Route path={Routes.DRIVER_POOL_WITH_ID.route} element={<DriverPool />} />
                <Route path={Routes.DAILY_SAND_ALLOCATIONS_WITH_ID.route} element={<DailySandAllocations />} />
                <Route path={Routes.JOB_METRICS_WITH_ID.route} element={<JobMetrics />} />
                <Route path={Routes.JOB_MAP_WITH_ID.route} element={<JobMap />} />
                <Route path={Routes.DASHBOARD.route} element={<Dashboard />} />
                <Route path={Routes.VOS_WITH_ID.route} element={<VosForTab />} />
                <Route path={Routes.MESSAGES_WITH_ID.route} element={<Messages />} />
                <Route path={Routes.MESSAGES_WITH_DRIVER_ID.route} element={<Messages />} />
                <Route path={Routes.MESSAGES_CREATE.route} element={<MessagesCreate />} />
                <Route path={Routes.DASHBOARD_VOS.route} element={<DashboardVos/>}/>
                <Route path={Routes.DASHBOARD_MAP.route} element={<DashboardMap/>}/>

            </Route>


            {/* <Route  path={Routes.JOB_MANAGEMENT.route} Component={JobManagement} /> */}
            {/* <PrivateRoute  path={Routes.JOB_MANAGEMENT_FOR_TAB.route} component={JobManagementForTab} />
            <PrivateRoute exact path={Routes.LOAD_MANAGEMENT.route} component={LoadManagement} />
            <PrivateRoute exact path={Routes.JOB_PROFILE_WITH_ID.route} component={JobProfile} />
            <PrivateRoute exact path={Routes.EDIT_JOB_WITH_ID.route} component={EditJob} />
            <PrivateRoute exact path={Routes.JOB_LOADS_WITH_ID.route} component={JobLoadsManagement} />
            <PrivateRoute exact path={Routes.LOAD_PROFILE_WITH_ID.route} component={LoadProfile} />
            <PrivateRoute exact path={Routes.LOAD_FIELD_OP_WITH_ID.route} component={LoadFieldOp} />
            <PrivateRoute exact path={Routes.DRIVER_REPORT.route} component={DriverReport} />
            <PrivateRoute exact path={Routes.POWER_BI_REPORT.route} component={SandboxBIReport} />
            <PrivateRoute exact path={Routes.SYSTEM_ADMIN_USERS.route} component={Users} />
            <PrivateRoute exact path={Routes.LOAD_HISTORY_WITH_ID.route} component={LoadHistory} />
            <PrivateRoute exact path={Routes.SYSTEM_ADMIN_PERMISSIONS.route} component={Permissions} />
            <PrivateRoute exact path={Routes.SYSTEM_ADMIN_LOFAS.route} component={Lofas} />
            <PrivateRoute exact path={Routes.SYSTEM_ADMIN_CUSTOMERS.route} component={Customers} />
            <PrivateRoute exact path={Routes.SYSTEM_ADMIN_CUSTOMER_PARENTS.route} component={CustomerParents} />
            <PrivateRoute exact path={Routes.SYSTEM_ADMIN_CREWS.route} component={Crews} />
            <PrivateRoute exact path={Routes.SYSTEM_ADMIN_DRIVERS.route} component={Drivers} />
            <PrivateRoute exact path={Routes.SYSTEM_ADMIN_CARRIERS.route} component={Carriers} />
            <PrivateRoute exact path={Routes.SYSTEM_ADMIN_PROPANTS.route} component={Propants} />
            <PrivateRoute exact path={Routes.SYSTEM_ADMIN_SETTINGS.route} component={Settings} />
            <PrivateRoute exact path={Routes.SYSTEM_ADMIN_YARDS.route} component={Yards} />
            <PrivateRoute exact path={Routes.JOB_ACTIVITY_WITH_ID.route} component={JobActivity} />
            <PrivateRoute exact path={Routes.STAGE_SUMMARY_WITH_ID.route} component={JobStageSummary} />
            <PrivateRoute exact path={Routes.STAGE_SHEET_WITH_ID.route} component={JobStageSheet} />
            <PrivateRoute exact path={Routes.STAGE_SHEET_RO_WITH_ID.route} component={JobStageSheetRO} />
            <PrivateRoute exact path={Routes.INVENTORY_WITH_ID.route} component={Inventory} />
            <PrivateRoute exact path={Routes.JOB_LOGS_WITH_ID.route} component={JobLogs} />
            <PrivateRoute exact path={Routes.ADD_BOXES_WITH_ID.route} component={AddBoxes} />
            <PrivateRoute exact path={Routes.DRIVER_POOL_WITH_ID.route} component={DriverPool} />
            <PrivateRoute exact path={Routes.DAILY_SAND_ALLOCATIONS_WITH_ID.route} component={DailySandAllocations} />
            <PrivateRoute exact path={Routes.JOB_MAP_WITH_ID.route} component={JobMap} />
            <PrivateRoute exact path={Routes.DASHBOARD.route} component={Dashboard} />
            <PrivateRoute exact path={Routes.MESSAGES.route} component={Messages} />
            <PrivateRoute exact path={Routes.MESSAGES_WITH_ID.route} component={Messages} />
            <PrivateRoute exact path={Routes.MESSAGES_WITH_DRIVER_ID.route} component={Messages} />
            <PrivateRoute exact path={Routes.MESSAGES_CREATE.route} component={MessagesCreate} /> */}
            <Route path={Routes.SILENT_RENEW.route} Component={SilentRenew} />
        </Switch>
    );
};

export default Content;
